export default __webpack_public_path__ + "static/media/kitchen5-afterB-768w.d7d577ce.png";